import React from "react";
import RadioButton from "../Buttons/RadioButton";
import "./SimpleCard.css"

type HeaderBaseProps = {
  title?: string;
  children?: React.ReactNode;
};

type RadioButtonProps = {
  radioButtonName: string;
  isRadioButtonSelected: boolean;
  radioButtonId: string;
  radioButtonOnChange: (id: string, value: boolean) => void;
};

type HeaderProps =
  | ({
      useRadioButton: false;
    } & HeaderBaseProps)
  | ({
      title?: string;
      children?: React.ReactNode;
      useRadioButton: true;
    } & HeaderBaseProps &
      RadioButtonProps);

const HeaderCard = ({
  title,
  children,
  useRadioButton,
  ...props
}: HeaderProps) => {
  const {
    isRadioButtonSelected,
    radioButtonId,
    radioButtonOnChange,
    radioButtonName,
  } = props as RadioButtonProps;

  const className = useRadioButton
    ? "simple-card-header with-radio-button"
    : "simple-card-header";

  return (
    <div className={className}>
      <div>
        {title !== undefined && <div className="simple-card-title">{title}</div>}
        {children}
      </div>

      {useRadioButton && (
        <div>
          <RadioButton
            id={radioButtonId}
            checked={isRadioButtonSelected}
            onChange={radioButtonOnChange}
            name={radioButtonName}
            color="alternate"
          />
        </div>
      )}
    </div>
  );
};

type SimpleCardProps = {
  children?: React.ReactNode;
  style?: React.CSSProperties;
};

const SimpleCard = ({ children, style }: SimpleCardProps) => {
  return (
    <div className="simple-card" style={style}>
      {children}
    </div>
  );
};

SimpleCard.Header = HeaderCard;

export default SimpleCard;
